import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase-config';

const useFetchAccordions = (companyId, selectedYear) => {
    const [quarters, setQuarters] = useState({ Q1: [], Q2: [], Q3: [], Q4: [] });
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        setIsLoading(true);
        setError(null);
        
        const yearDocRef = doc(db, `companies/${companyId}/accordions/YearSelect/years/${selectedYear}`);
        
        const unsubscribe = onSnapshot(yearDocRef, (docSnapshot) => {
            if (docSnapshot.exists()) {
                setQuarters(docSnapshot.data());
            } else {
                setError("No data found for the selected year");
            }
            setIsLoading(false);
        }, (error) => {
            setError(error.message);
            setIsLoading(false);
        });

        return () => unsubscribe();
    }, [companyId, selectedYear]);

    return { quarters, setQuarters, isLoading, error };
};

export default useFetchAccordions;



